import React from 'react';
import { FONT } from '../constants';
import { C } from '../styles';
import { sectionStatus } from '../helpers';
import type { Section, Values } from '../types';

interface Props {
  sections: Section[];
  values: Values;
  openId: string | null;
  editingId: string | null;
  onPick: (sid: string) => void;
}

export default function Rail({ sections, values, openId, editingId, onPick }: Props) {
  return (
    <div style={{
      background: '#fff',
      border: '1px solid ' + C.line,
      borderRadius: 15,
      padding: 8,
      position: 'sticky',
      top: 20,
      boxShadow: '0 1px 2px rgba(16,26,43,0.04)',
    }}>
      {sections.map((s) => {
        const st = sectionStatus(s, values);
        const on = openId === s.id;
        const Icon = s.icon;
        const disabled = Boolean(editingId) && editingId !== s.id;
        const dotColor = st === 'done' ? C.green : (st === 'edit' ? C.teal : C.amber);
        return (
          <button
            key={s.id}
            onClick={() => onPick(s.id)}
            disabled={disabled}
            style={{
              display: 'flex', alignItems: 'center', gap: 11,
              width: '100%', border: 0,
              background: on ? C.tealSoft : 'none',
              fontFamily: FONT, fontSize: 13.5,
              fontWeight: on ? 600 : 500,
              color: on ? C.tealInk : C.text,
              padding: '11px 12px', borderRadius: 10,
              cursor: disabled ? 'not-allowed' : 'pointer',
              textAlign: 'left',
              opacity: disabled ? 0.5 : 1,
            }}
          >
            <span style={{
              width: 18, height: 18,
              color: on ? C.tealInk : '#000000',
              flex: '0 0 18px',
            }}>
              <Icon size={18} />
            </span>
            <span style={{ flex: 1 }}>{s.title}</span>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: dotColor }} />
          </button>
        );
      })}
    </div>
  );
}